import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite} from "gsap";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";

export class DogfightWinPresentation extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "DogfightWinPresentation";
        this.init();
    }

    public hide(duration:number = 0.0001):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.to(this, {duration : duration, alpha : 0});
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    public onResize():void {
        if(!this.visible) {
            return;
        }
    }

    public show(column:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        this.onResize();
        this.alpha = 1;
        this.visible = true;
        const hit:boolean = PearlHarbor.model.dogfight.mgHit[column],
            value:number = PearlHarbor.cocpitBoard.columnSums[column],
            dir:number = Math.floor(Math.random() * 4),
            dirName:string = ["up", "down", "left", "right"][dir];

        tl.add(PearlHarbor.cocpitBoard.addColumnWinInMiddle(column));
        tl.add([
            () => {
                PearlHarborSoundManager.onFsDogfightShow();
                PearlHarborSoundManager.onFsDogFightAnimationStart(dir);
                PearlHarbor.hitChanceBoard.displayHitChance(column, false)
            },
        ]);
        tl.add(PearlHarbor.backgroundElements.playCockpitAnimation(`dogfight_${dirName}_${hit ? "hit" : "miss"}`), `+=1.2`);
        tl.add(() => {
            PearlHarborSoundManager.onFsDogFightHit(hit, dir);
            PearlHarbor.hitChanceBoard.displayHitResult(column, false);
            if(!hit) {
                PearlHarbor.cocpitBoard.playMissMul();
            }else{
                PearlHarborHelper.shakeScreen();
            }
        }, `-=0.7`);
        if(hit) {
            tl.add(PearlHarbor.cocpitBoard.updateMultiplier(value, 0.1));
        }
        tl.add([
            () => {PearlHarborSoundManager.onFsDogfightEnd();},
            this.hide(0.5)
        ]);
        tl.add(PearlHarbor.cocpitBoard.afterColumnWin(column));
        return tl;
    }


    public onAbort(level:number):void {

    }


    private init():void {
        this.visible = false;
    }
}